import * as url from "../url_helper"
import { del, get, getWithOutAuth, post } from "../api_helper";
import {
    GET_ALL_CHANNEL_TYPE_API_END_POINT, GET_TRACKING_API_END_POINT,
    MARKETPLACE_DETAILS_CONFIG_UPDATE_END_POINT, NETWORK_INTEGRATIONS_API_END_POINT,
    POST_NETWORK_INTEGRATIONS_API_END_POINT, TENANTS_APP_CHANNEL_API_END_POINT
} from "../url_helper";

export const getVendorData = () => get(url.Get_Vendor_Data);
export const getVendorCarrierData = (data) => get(url.Get_Vendor_Carrier_Data+data);
export const getCurrencyData = () => get(url.Get_Currency_Data);
export const getUomData = () => get(`${url.Get_Uom_Data}`);
export const getUomWeightData = () => get(url.Get_Uom_Data + '?weightParameterOnly=true');
export const getOceanPortData = () => get(url.Get_Ocean_Port_Data);
export const getCargoTypeData = () => get(url.Get_Cargo_Type_Data);
export const getCommodityData = () => get(url.Get_commodity_data);
export const getContainerData = () => get(url.Get_Container_Data);
export const getStateAllSer = () => get(url.Get_State_ALL_URL);
export const getRoleAllSer = () => get(url.ROLE_URL);
export const saveRoleSer=(data) => post(url.ROLE_URL,data)
export const getRoleById=(id) => get(`${url.ROLE_URL}${id}`)
export const getModuleAllSer=(data) => get(url.GET_MODULE_URL + `?isAdmin=${data}`);
export const deletePermissionser = (roleId, moduleId, RolName) =>del(`${url.DELETE_PERMISSIONS}${roleId}/${moduleId}/${RolName}`);
export const savePermissionSer = (data, id) =>post(`${url.Save_PERMISSIONS}/${id}`,data);
export const getAllmodulesbyrole=() =>get(url.GET_ALL_MODULES_BY_ROLE)
export const getAllOceanPortTerminals=() =>get(url.GET_ALL_OCEAN_PORT_TERMINALS)
export const getAllStatusMaster=() =>get(url.GET__STATUS_MASTER)
export const getAllReasonMaster=() =>get(url.GET__REASON_MASTER)
export const getAllTaxCode=() =>get(url.GET_ALL_TAX_CODE)

export const emailSendNotification=(data) => post(url.EMAIL_SEND_NOTIFICATION,data)

export const getAllSectorMaster=() =>get(url.GET_SECTOR_MASTER)

//Tracking
export const trackingApiCall = (data) => post(url.GET_TRACKING_API_END_POINT, data);
//Sailing Schedule
export const sailingScheduleApiCall = (data) => post(url.GET_SAILING_SCHEDULE_API_END_POINT, data);

// surcharge
export const getSurchargeCodeData = () => get(url.Get_surcharge_code_Data);
export const getSurchargeCategoryData = () => get(url.Get_surcharge_category_Data);
export const getSurchargeAliceSer = () => get(url.Get_Surcharge_Alice_Data);
export const postSurchargeCodeSer = (data) => post(url.Post_Surcharge_Data, data);
export const postSurchargeCateSer = (data) => post(url.POST_SURCHARGE_CATE_URL, data);
export const postSurchargeAliseSer = (data) => post(url.POST_SURCHARGE_ALISE_URL, data);

// Image Download
export const GetFileSer = (base64Encoded) => getWithOutAuth(url.Get_File_URL + base64Encoded);

export const getAllFilesSer= () => get(url.Get_All_File_URL)

// instant rate search droup downs
export const getInstantRateLocation = () => get(url.GET_INSTANT_RATE_LOCATION);
export const getAirLocation = () => get(url.GET_AIR_LOCATION_URL);
export const getAllIncoTerms = () => get (url.GET_ALL_INCOTERM)

// tenant location
export const getAllTenantLocation = () => get (url.GET_ALL_TANANT_LOCATION);
export const postTenantLocation = (data) => post(url.POST_TANANT_LOCATION, data);

// tenant location type
export const getAllTenantLocationType = () => get (url.GET_ALL_TANANT_LOCATION_TYPE);
export const postTenantLocationType= (data) => post (url.POST_TANANT_LOCATION_TYPE, data);

export const getUploadStatus = () => get(url.Get_Upload_Status);

//market place details update
export const postMarketPlaceDetailsUpdate = (payload) => post(url.MARKETPLACE_DETAILS_CONFIG_UPDATE_END_POINT, payload);

export const postNetworkIntegrationsApi = payload => {
    return post(url.NETWORK_INTEGRATIONS_API_END_POINT, payload, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    })
}

export const getNetworkIntegrationsApi = () => get (url.NETWORK_INTEGRATIONS_API_END_POINT);

export const getAllChannelTypesApi = () => get (url.GET_ALL_CHANNEL_TYPE_API_END_POINT);

export const postTenantsAppChannelApi = (payload) => post(url.TENANTS_APP_CHANNEL_API_END_POINT, payload);

export const getTenantsAppChannelApi = () => get(url.TENANTS_APP_CHANNEL_API_END_POINT);

